import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const BASE = `${String(url).replace(/\/+$/, "")}/api/targets`;

async function request(path, options = {}) {
  const endpoint = `${BASE}${path}`;
  const response = await fetchWithAuth(endpoint, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `Request failed ${response.status}`);
  }
  return response.json();
}

export const targetsApi = {
  list: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.archived !== undefined) sp.set("archived", String(params.archived));
    if (params.search) sp.set("search", params.search);
    const qs = sp.toString();
    return request(qs ? `?${qs}` : "");
  },
  getById: (id) => request(`/${id}`),
  create: (payload) => request("", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => request(`/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  archive: (id) => request(`/${id}/archive`, { method: "POST" }),
  employees: () => request("/employees"),
  my: () => request("/my"),
};
